<template>
    <div class="mainMenu">
        <div class="menuBtnLogin" :style="this.user.color ? `background-color: ${this.user.color};` : ''">
            {{ this.user.login }}
            <div class="test-period" v-if="this.user.access_date">Тестовый период до: {{
                formatDate(this.user.access_date) }}</div>
        </div>
        <router-link class="menuBtn" active-class="menuBtnActive" exact to="/orders">Заказы</router-link>
        <router-link class="menuBtn" v-if="this.isAdmin" active-class="menuBtnActive" exact
            to="/workers">Мастера</router-link>
        <router-link class="menuBtn" v-if="this.isAdmin" active-class="menuBtnActive" exact
            to="/expenses">Расходы</router-link>
        <router-link class="menuBtn" active-class="menuBtnActive" exact to="/planer">Планер</router-link>
        <router-link v-if="this.isAdmin" class="menuBtn" active-class="menuBtnActive" exact to="/statistics">Статистика</router-link>
        <router-link class="menuBtn" active-class="menuBtnActive" exact to="/regulars">Постоянники</router-link>
        <!-- <router-link class="menuBtn" active-class="menuBtnActive" exact to="/calendar">Календарь</router-link> -->
        <router-link class="menuBtn" active-class="menuBtnActive" exact to="/login" @click="exit()">Выход</router-link>
    </div>
</template>
<script>

export default {
    name: "MainMenu",
    methods: {
        formatDate(inputDate) {
            const [year, month, day] = inputDate.split('-');
            return `${day}.${month}.${year}`;
        },
        exit() {
            localStorage.removeItem('entry_key');
            this.setUser(null);
        }
    },
    computed: {

    }
}
</script>
<style scoped>
.mainMenu {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 10px;
    padding: 10px;
    background: var(--block-content);
    border-radius: 10px;
}

.menuBtn {
    text-decoration: none;
    color: #00000057;
    font-weight: bold;
    transition: all .3s;
    cursor: pointer;
}

.menuBtn:hover {
    opacity: .5;
}

.menuBtn.menuBtnActive {
    color: black;
}

.menuBtnLogin {
    margin-right: auto;
    padding: 5px;
    border-radius: 5px;
    position: relative;
}

.test-period {
    position: absolute;
    top: 20px;
    left: 0;
    box-shadow: 0px 0px 4px -2px #ff6a00;
    background: white;
    padding: 5px;
    font-size: 10px;
    opacity: .5;
    white-space: nowrap;
    color: red;
    pointer-events: none;
    border-radius: 5px;
}
</style>
